
/**
 * @export
 * @enum {string}
 */
export enum FrequencyUnit {
    MINUTES = 'MINUTES',
    HOURS = 'HOURS',
    DAYS = 'DAYS'
}